// extracted by mini-css-extract-plugin
export default {"form":"InternetRuleForm_form__xlkn+","form__button":"InternetRuleForm_form__button__KN0o6"};